//Сплющиваем список инсайдеров в строки таблицы трейдов: один latest_trade = одна строка.
//Трейды без latest_trade (теоретически невозможные при unique_markets_count>0) отбрасываются.
export const mapInsidersToTrades = (users = []) =>
  users
    .filter(user => user?.latest_trade)
    .map(user => ({
      ...user.latest_trade,
      insider: {
        unique_markets_count: user.unique_markets_count,
        max_bet_usd: user.max_bet_usd,
        open_positions_value_usd: user.open_positions_value_usd,
      },
    }));
